export default __webpack_public_path__ + "static/ghost_baffled-0c8e6420db46363ea247a7568b189111.svg";